<template><section><template>
<h3>Slider</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-slider v-model="value" @change="change" orientation="vertical"></n3-slider>
<p> {{value}}</p> 
<p><n3-slider v-model="value1" @change="change" :range="true"></n3-slider></p>
<p> {{value1}}</p> 
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-slider</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"change"</span> <span class="hljs-attr">orientation</span>=<span class="hljs-string">"vertical"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-slider</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-slider</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value1"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"change"</span> <span class="hljs-attr">:range</span>=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-slider</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">value</span>: <span class="hljs-number">2</span>
    }
  },
  <span class="hljs-attr">methods</span>: {
    change (val) {
      <span class="hljs-built_in">console</span>.log(val)
    }
  }
}
</code></pre>
<h3>Params</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>type</th>
<th>default</th>
<th>description</th>
</tr>
</thead>
<tbody>
<tr>
<td>min</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">0</code></td>
<td>min value</td>
</tr>
<tr>
<td>max</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">0</code></td>
<td>max value</td>
</tr>
<tr>
<td>step</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">1</code></td>
<td>step value</td>
</tr>
<tr>
<td>orientation</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">horizontal</code></td>
<td><code v-pre="">horizontal</code> <code v-pre="">vertical</code></td>
</tr>
<tr>
<td>range</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>range support</td>
</tr>
<tr>
<td>tooltip</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">show</code></td>
<td>tooltip  one of 'show' 'hide' 'always'</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>disabled</td>
</tr>
<tr>
<td>formatter</td>
<td><code v-pre="">Function</code></td>
<td>-</td>
<td>tooltip format function</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">220px</code></td>
<td>width</td>
</tr>
<tr>
<td>height</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">220px</code></td>
<td>height</td>
</tr>
</tbody>
</table>
<h3>Events</h3>
<table>
<thead>
<tr>
<th>name</th>
<th>description</th>
<th>params</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>value change</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>PS: params of form components，look <a href="#n3FormDocs">Form</a> </p>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      value:1,
      value1: [1, 2]
    }
  },
  methods: {
    change (val) {
      console.log(val)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3SliderDocs.md?34020d09